/**
 * Builds a formatted URL with query parameters.
 * @param {string} origin - The origin of the URL.
 * @param {string} url - The path of the URL.
 * @param {string | string[][] | Record<string, string> | URLSearchParams | undefined} params - The query parameters object.
 * @returns {string} - The formatted URL.
 */
function buildUrl(origin, url, params) {
  const queryParams = new URLSearchParams(params);
  return `${origin}${url}&${queryParams.toString()}`;
}

export default buildUrl;
